import { useQuery } from "react-query";
import fetchJson from "./fetchJson";

const useSearch = (keyword, pageNumber, pageSize, mealType) => {
  const API_KEY = process.env.REACT_APP_SPOONACULAR_API_KEY;

  // fetch food by keyword and meal type
  const fetchFood = async () => {
    const data = await fetchJson(
      `https://api.spoonacular.com/recipes/complexSearch?apiKey=${API_KEY}&query=${encodeURIComponent(
        keyword
      )}&addRecipeInformation=true&number=${pageSize}&offset=${
        pageSize * pageNumber
      }&type=${encodeURIComponent(mealType)}`
    );
    return {
      results: data.results ?? [],
      totalResults: data.totalResults ?? 0,
    };
  };
  return useQuery(
    ["recipes", keyword, pageNumber, pageSize, mealType],
    fetchFood,
    {
      refetchOnWindowFocus: false,
      staleTime: 60000, // cache for 1 minute
      keepPreviousData: true,
    }
  );
};

export default useSearch;
